// extracted by css-extract-rspack-plugin
var _1 = "teWQGap7k0M7JUUh";
var _2 = "aoC_HnJkiqcP1FKb";
export { _1 as "highlight", _2 as "underline" }
